import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  meta: {
    title: '首页'
  },
  component: () => import('../views/Home.vue')
},
{
  path: '/home',
  name: 'home',
  meta: {
    title: '首页'
  },
  component: () => import('../views/Home.vue')
},
{
  path: '/login',
  name: 'login',
  component: () => import('../views/login.vue'),
  meta: {
    title: '登录页'
  },
},
{
  path: '/toURLlink',
  name: 'toURLlink',
  component: () => import('../views/toURLlink.vue'),
  meta: {
    title: '跳转小程序'
  },
},
{
  path: '/demo',
  name: 'demo',
  component: () => import('../views/demo.vue')
},
{
  path: '/logins',
  name: 'logins',
  component: () => import('../views/logins.vue'),
  meta: {
    title: '登录页'
  },
},
{
  path: '/about',
  name: 'About',
  component: () => import('../views/About.vue')
},
{
  path: '/examination',
  name: 'examination',
  component: () => import('../views/examination.vue'),
  meta: {
    title: '答题-题目详情'
  },
},
{
  path: '/achievements',
  name: 'achievements',
  component: () => import('../views/achievements.vue'),
  meta: {
    title: '考试成绩页'
  },
},
{
  path: '/answerView',
  name: 'answerView',
  meta: {
    title: '解析-题目详情'
  },
  component: () => import('../views/answerView.vue')
},
//studyEvaluation
{
  path: '/studyEvaluation',
  name: 'studyEvaluation',
  meta: {
    title: '学习测评'
  },
  component: () => import('../views/studyEvaluation.vue')
},
{
  path: '/prizesDetails',
  name: 'prizesDetails',
  meta: {
    title: '获奖名单'
  },
  component: () => import('../views/prizesDetails.vue')
},
{
  path: '/detail',
  name: 'detail',
  meta: {
    title: '新人福利领取'
  },
  component: () => import('../views/detail.vue')
},
{
  path: '/ranking',
  name: 'ranking',
  meta: {
    title: '排行榜'
  },
  component: () => import('../views/ranking/index.vue')
},

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  let { agentCode, cardID } = to.query
  await store.dispatch('setGuid')
  await store.dispatch("agent", { agentCode, cardID });
  next()
})
export default router